module.exports = __webpack_public_path__ + "img/UNIONPAY.5c73b367.svg";